import { render, staticRenderFns } from "./Cashregisters.vue?vue&type=template&id=4ec136de&"
import script from "./Cashregisters.vue?vue&type=script&lang=js&"
export * from "./Cashregisters.vue?vue&type=script&lang=js&"
import style0 from "./Cashregisters.vue?vue&type=style&index=0&id=4ec136de&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports